
export default class MarkData
{
    public code:string;
    public position:number;

    constructor(code?:string, position?:number)
    {
        this.code = code;
        this.position = position;
    }
}